var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"mini-popup absolute border rounded-lg shadow hover:shadow-lg p-4 max-w-full",class:{
    'mini-popup_center': _vm.position === _vm.MiniPopupPosition.Center,
    'mini-popup_top': _vm.position === _vm.MiniPopupPosition.Top,
  }},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }